import { Observable } from 'rxjs';
import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { WebErrorCode } from '../model/web-error-code.model';
import { Router } from '@angular/router';
import { EnvironmentInjector, inject } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { UserStore } from '../store/user/user.store';
import { ROUTE_REGISTRATION_WIZARD } from '../app.constants';
import { IkpPopupService } from '@shared-ikp/service/popup/popup.service';

const IGNORED_PATH = '/';

export function errorResponseInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const router = inject(Router);
  if (IGNORED_PATH.includes(router.url)) {
    return next(req);
  }

  const injector = inject(EnvironmentInjector);
  const popupService = inject(IkpPopupService);
  return next(req).pipe(
    catchError(async error => {
      //inject UserStore lazy in observable chain to avoid cyclic dependency
      const userStore = injector.get(UserStore);
      if (await isUserNotFoundError(error)) {
        popupService.disablePopups();
        userStore.loadUserStatus().then(() => {
          router.navigate([ROUTE_REGISTRATION_WIZARD]);
        });
      }
      throw error;
    }),
  );
}

async function isUserNotFoundError(errorResponse: HttpErrorResponse): Promise<boolean> {
  if (errorResponse.status !== 403) {
    return false;
  }

  //Download functions return a blob instead of string body, so we need to parse them.
  const error = errorResponse.error instanceof Blob ? await errorResponse.error.text() : String(errorResponse.error);
  return error === WebErrorCode.UNKNOWN_USER;
}
